<template>
  <div>
    <hr />

    <!-- Filtro de búsqueda por nombre -->
    <div class="mb-3 d-flex align-items-center gap-2">
      <label for="nombreBusqueda" class="form-label mb-0 fw-bold">Nombre</label>
      <input
        type="text"
        class="form-control"
        id="nombreBusqueda"
        v-model="nombreBusqueda"
        style="width: 500px; text-transform: uppercase"
        @keyup.enter="buscar"
      />
      <button class="btn btn-light" @click="buscar" title="Buscar">
        <span class="material-icons" style="font-size:20px; color:blue">search</span>
        Buscar
      </button>
    </div>

    <!-- DataTable -->
    <DataTable
      :data="elempress"
      :columns="columnas"
      idField="idElemPres"
      :mostrarVer="true"
      :mostrarEditar="true"
      :mostrarEliminar="false"
      mensajeVacio="No hay elementos de prestador disponibles."
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="(row) => abrirModalEditar(row.idElemPres)"
      @view="(row) => abrirEditar(row.idElemPres)"
      @delete="(row) => deleteElemPres(row.idElemPres)"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <!-- ID (solo edición) -->
              <div class="mb-3 row" v-if="btnEditar">
                <label class="col-2 col-form-label">IdElemPres</label>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoElemPres.idElemPres" disabled />
                </div>
              </div>

              <!-- Prestador -->
              <div class="mb-3 row">
                <label class="col-2 col-form-label">Prestador</label>
                <div class="col-10">
                  <select class="form-control" v-model="datoElemPres.idPrestador">
                    <option
                      v-for="prestador in prestadors"
                      :value="prestador.idPrestador"
                      :key="prestador.idPrestador"
                    >
                      {{ prestador.nombre }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Código -->
              <div class="mb-3 row">
                <label class="col-2 col-form-label">Código</label>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoElemPres.codigo"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>

              <!-- Nombre -->
              <div class="mb-3 row">
                <label class="col-2 col-form-label">Nombre</label>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoElemPres.nombre"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              class="btn btn-light"
              @click.prevent="guardarElemPres"
              title="Guardar"
            >
              <span class="material-icons" style="font-size:28px; color:blue">save</span>
            </button>
            <button
              v-if="btnEditar"
              class="btn btn-light"
              @click.prevent="guardarEditElemPres"
              title="Actualizar"
            >
              <span class="material-icons" style="font-size:28px; color:blue">update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
import DataTable from "@/components/DataTable.vue"; // ajusta la ruta según tu proyecto

export default {
  components: { DataTable },

  props: {
    p_idEmpresa:   { type: Number, required: true },
    p_idPrestador: { type: Number, required: true },
  },

  data() {
    return {
      elempress:      [],
      datoElemPres:   {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      prestadors:     [],

      // Definición de columnas para DataTable
      columnas: [
        { field: "codigo", label: "Código" },
        { field: "nombre", label: "Nombre" },
      ],
    };
  },

  mounted() {
    this.getDataPaginaTodos();
    this.fetchPrestadors();
  },

  methods: {
    // ── Búsqueda ──────────────────────────────────────────────────
    buscar() {
      if (!this.nombreBusqueda.trim()) {
        this.getDataPaginaTodos();
        return;
      }
      api.get("/vwelempress/nombre/" + this.nombreBusqueda)
        .then((response) => {
          this.elempress = response.data.reverse();
        });
    },

    getDataPaginaTodos() {
      api.get("/vwelempress/idprestador/" + this.p_idPrestador)
        .then((response) => {
          this.elempress = response.data.reverse();
        });
    },

    // ── Validación ────────────────────────────────────────────────
    validarFormulario() {
      const campos = ["idPrestador", "codigo", "nombre"];
      return validarForm(this.datoElemPres, campos, campos);
    },

    // ── CRUD ──────────────────────────────────────────────────────
    async guardarElemPres() {
      if (this.validarFormulario() !== 1) return;
      try {
        await api.post("/elempress", this.datoElemPres);
        $("#ventanaModal").modal("hide");
        swal("Correcto!", "ElemPres creada exitosamente!", "success");
        this.getDataPaginaTodos();
      } catch {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },

    async guardarEditElemPres() {
      if (this.validarFormulario() !== 1) return;
      try {
        await api.post("/elempress", this.datoElemPres);
        $("#ventanaModal").modal("hide");
        swal("Correcto!", "ElemPres actualizada exitosamente!", "success");
        this.getDataPaginaTodos();
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },

    async deleteElemPres(idElemPres) {
      try {
        await api.delete("/elempress/" + idElemPres);
        this.getDataPaginaTodos();
      } catch {
        swal("Error!", "No se pudo eliminar el registro.", "error");
      }
    },

    // ── Modal ─────────────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoElemPres = {};
      this.titulo       = "Crear ElemPres";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirModalEditar(idElemPres) {
      this.modalWindow = true;
      this.titulo      = "Editar ElemPres";
      this.btnCrear    = false;
      this.btnEditar   = true;
      api.get("/vwelempress/" + idElemPres).then((resp) => {
        this.datoElemPres = resp.data;
        this.$nextTick(() => $("#ventanaModal").modal("show"));
      });
    },

    abrirEditar(idElemPres) {
      if (idElemPres != null) {
        this.$router.push("/elempres_elemequi/" + idElemPres);
      }
    },

    // ── Datos auxiliares ──────────────────────────────────────────
    fetchPrestadors() {
      api.get("/vwprestadors/idempresa/" + this.p_idEmpresa)
        .then((response) => { this.prestadors = response.data; })
        .catch((error)   => { console.error("Error fetching prestadors:", error); });
    },
  },
};
</script>